import { BaseModel } from "model/BaseModel";

export default class Deposito implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    ativo: boolean;

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        ativo = true,
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.ativo = ativo;
    }
}